import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import _ from 'underscore';
import JobListingsEntry from './JobListingsEntry';
export const JobListings = () => {
    const [jobListings, setJobListings] = useState(null);
    const [functionGroupsList, setFunctionGroupsList] = useState(null);
    const [displayedJobListings, setDisplayedJobListings] = useState(null);
    const [availableCategories, setAvailableCategories] = useState(null);
    const [currentCategory, setCurrentCategory] = useState(null);
    const [searchFilter, setSearchFilter] = useState(null);
    const allCategoriesLabel = { id: 0, label: 'All Functional Areas' };
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const handleWindowResize = () => {
        setWindowWidth(window.innerWidth);
    };
    // Get all vacancies
    useQuery('allJobListings', async () => {
        return fetch(`/api/hatchery/vacancies/`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
            setJobListings(data.vacancyFeed.vacancy);
        })
            .catch(error => {
            console.error('Error:', error);
        });
    }, { staleTime: Infinity });
    // Get all vacancies
    useQuery('allFunctionGroups', async () => {
        return fetch(`/api/hatchery/function-groups/`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(response => response.json())
            .then(data => {
            setFunctionGroupsList(data.functiongroup);
        })
            .catch(error => {
            console.error('Error:', error);
        });
    }, { staleTime: Infinity });
    // Handle height adjustment of entries on resize
    useEffect(() => {
        window.addEventListener('resize', () => {
            _.throttle(handleWindowResize(), 100);
        }, false);
    }, []);
    // Get available categories from all vacancies
    useEffect(() => {
        async function parseCategories() {
            if (jobListings) {
                setDisplayedJobListings(jobListings);
                const parsedCategories = [allCategoriesLabel];
                jobListings.forEach(listing => {
                    // get all three functionGroups
                    let listingFunctionGroups = [listing.functionGroupId, listing.functionGroupId2, listing.functionGroupId3];
                    // filter the null values
                    listingFunctionGroups = listingFunctionGroups.filter(entry => entry !== null);
                    if (functionGroupsList && listingFunctionGroups) {
                        // search for matching label
                        const matchingFunctionGroup = Object.values(functionGroupsList).find(entry => {
                            return listingFunctionGroups.includes(entry['id']);
                        });
                        if (!matchingFunctionGroup) {
                            return null;
                        }
                        const functionGroup = {
                            id: matchingFunctionGroup?.id,
                            label: matchingFunctionGroup?.label,
                        };
                        // add to array only if is not already included
                        if (!parsedCategories.some(entry => entry.id === functionGroup.id)) {
                            // only if the label is defined
                            if (functionGroup.label) {
                                parsedCategories.push(functionGroup);
                            }
                        }
                    }
                });
                setAvailableCategories(parsedCategories);
            }
        }
        parseCategories();
    }, [jobListings, functionGroupsList]);
    // Filter vacancies
    useEffect(() => {
        let availableJobListings = jobListings;
        if (searchFilter && searchFilter.length > 0 && availableJobListings) {
            availableJobListings = availableJobListings.filter(entry => {
                return entry.advertText.displayJobTitle?.toLowerCase().includes(searchFilter.toLowerCase());
            });
        }
        if (currentCategory && currentCategory !== allCategoriesLabel.id.toString() && availableJobListings) {
            availableJobListings = availableJobListings.filter(entry => {
                // check if category matches one of the functionGroups
                if (entry.functionGroupId?.toString() === currentCategory ||
                    entry.functionGroupId2?.toString() === currentCategory ||
                    entry.functionGroupId3?.toString() === currentCategory) {
                    return true;
                }
            });
        }
        setDisplayedJobListings(availableJobListings);
    }, [searchFilter, currentCategory]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'filter-bar' },
            React.createElement("div", { className: 'form-field dropdown' },
                React.createElement("div", { className: 'control is-dark' },
                    React.createElement("select", { name: 'selected-category', onChange: event => {
                            setCurrentCategory(event.currentTarget.value);
                        } }, availableCategories &&
                        availableCategories.map(category => (React.createElement("option", { key: category.id, value: category.id }, category.label)))))),
            React.createElement("div", { className: 'form-field search' },
                React.createElement("div", { className: 'control' },
                    React.createElement("img", { src: '/assets/dist/images/icon-search.svg', alt: 'Search icon', className: 'icon' }),
                    React.createElement("input", { type: 'text', placeholder: 'Search here', onChange: event => {
                            setSearchFilter(event.currentTarget.value);
                        } })))),
        React.createElement("div", { className: 'job-listings-container' }, displayedJobListings &&
            displayedJobListings
                .filter(entry => !!entry.advertText.displayJobTitle)
                .map(entry => (React.createElement(JobListingsEntry, { key: entry.id, id: entry.id, title: entry.advertText.displayJobTitle, headline: 'Function Description', text: entry.advertText.description, windowWidth: windowWidth }))))));
};
export default JobListings;
